import React from 'react';
import ParallaxElement from '../common/ParallaxElement';

export default class Enemies extends React.Component {
    static propTypes = {};
    render() {
        return (
            <div className="enemies-wrapper">
                <ParallaxElement yStrength={0} xStrength={0.05} id="enemies" exitLeft>
                    <div className="enemies" />
                </ParallaxElement>
            </div>
        );
    }
}

